<template>
  <div>
    <el-dialog :title="title" :visible.sync="visible" width="880px" class="my-dialog-template" :close-on-click-modal="false">
      <div class="text1" v-if="type == 'add' || type == 'init'">
        <span>产品</span>
        将自动按照下放占比完成服务费配置,您也可以随之修改
      </div>
      <div class="text1" v-else>
        <span>选中产品</span>
        将自动按下方比例完成服务费配置
      </div>
      <el-table ref="singleTable" :data="tableData" class="list-table" border style="width: 100%">
        <el-table-column property="name" min-width="200" label=" " show-overflow-tooltip>
          <template slot-scope="scope"> {{ formData.type == 1 ? '团队' : '业务员' }}服务费 = 一级机构服务费 x </template>
        </el-table-column>
        <el-table-column property="name" min-width="100" label="首年(%)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="feeData.rate" type="number" size="small" min="0" max="100" step="0.01" @input="inputNum('rate')"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="name" min-width="100" label="第二年(%)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="feeData.rate2" type="number" size="small" min="0" max="100" step="0.01" @input="inputNum('rate2')"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="name" min-width="100" label="第三年(%)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="feeData.rate3" type="number" size="small" min="0" max="100" step="0.01" @input="inputNum('rate3')"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="name" min-width="100" label="第四年(%)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="feeData.rate4" type="number" size="small" min="0" max="100" step="0.01" @input="inputNum('rate4')"></el-input>
          </template>
        </el-table-column>
        <el-table-column property="name" min-width="100" label="第五年(%)" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model="feeData.rate5" type="number" size="small" min="0" max="100" step="0.01" @input="inputNum('rate5')"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div class="form-info-text">按比例设置后服务费可能出现小数，保留小数位数：</div>
      <el-radio-group v-model="scale">
        <el-radio label="2">不保留</el-radio>
        <el-radio label="3">保留1位</el-radio>
        <el-radio label="4">保留2位</el-radio>
      </el-radio-group>
      <div class="line"></div>
      <div class="form-info-text2">
        <b>举例：</b>
        <span v-if="scale == 2">一级机构服务费为72.50%，您为{{ value }}设置的产品服务费占比为75%，则{{ value }}产品的服务费为72.50% × 75.00%=54%。</span>
        <span v-if="scale == 3">一级机构服务费为80.00%，您为{{ value }}设置的产品服务费占比为72.00%，则{{ value }}产品的服务费为80.00% × 72.00%=57.6%。</span>
        <span v-if="scale == 4">一级机构服务费为72.50%，您为{{ value }}设置的产品服务费占比为75%，则{{ value }}产品的服务费为72.50% × 75.00%=54.37%。</span>
        <br />
        <span v-if="type == 'add'">如暂不设置，该比例将自动设置为0。新模板内全部产品费率为0，如需修改，请到费率模板详情<b>修改占比</b>！</span>
      </div>
      <div class="dialog-footer" v-if="type == 'add'">
        <el-button type="warning" plain @click="visible = false">上一步</el-button>
        <el-button type="warning" plain v-loading="loading" @click="save(formData, false)">暂不设置</el-button>
        <el-button type="warning" class="bgBtn" v-loading="loading" @click="save(formData, true)">保存</el-button>
      </div>
      <div class="dialog-footer" v-else>
        <el-button type="warning" plain @click="visible = false">取消</el-button>
        <el-button type="warning" class="bgBtn" v-loading="loading" @click="save(formData, true)">保存</el-button>
      </div>
    </el-dialog>
    <modalLoading ref="modalLoading" class="modal-loading"></modalLoading>
  </div>
</template>
<script>
import modalLoading from "@/components/modalLoading";
export default {
  data: () => ({
    visible: false,
    loading: false,
    type: "",
    formData: {},
    tableData: [{}],
    scale: '4',//小数位数
    feeData: {
      rate: 0,
      rate2: 0,
      rate3: 0,
      rate4: 0,
      rate5: 0,
    },
    title: "",
  }),
  computed: {
    value() {
      return this.formData.type == '1' ? '二级团队' : '业务员';
    }
  },
  components: { modalLoading },
  mounted() { },
  methods: {
    open(data = {}, type) {
      this.type = type;
      console.log(data)
      this.formData = JSON.parse(JSON.stringify(data))
      this.scale = this.formData.scale || '4';
      this.feeData.rate = this.formData.rate || 0;
      this.feeData.rate2 = this.formData.rate2 || 0;
      this.feeData.rate3 = this.formData.rate3 || 0;
      this.feeData.rate4 = this.formData.rate4 || 0;
      this.feeData.rate5 = this.formData.rate5 || 0;
      if (type == 'init') {
        this.title = "产品费率比";
      } else if (type == 'add') {
        this.title = "设置产品服务费占比";
      } else {
        this.title = "批量设置服务费";
      }
      this.visible = true
    },
    // 监控数字输入
    inputNum(key) {
      let fee = this.feeData[key];
      if (fee) {
        const feeArr = fee.toString().split("\.")
        // 小数位超过2位舍弃后面的
        if (feeArr[1] && feeArr[1].length > 2) {
          // 避免*100出现精度问题
          fee = Math.floor((fee * 100).toFixed(1)) / 100;
        }
        // fee=Math.floor(fee);
        if (fee > 100) {
          fee = 100;
        }
        if (fee < 0) {
          fee = 0;
        }
        this.$set(this.feeData, key, fee)
        // this.fee = fee;
      }
      console.log(fee);
    },
    save(data, updateFee) {
      if (this.loading) return
      this.loading = true;
      let url = '/master/commissonTemplate/saveTemplate';//新增编辑模板
      const params = JSON.parse(JSON.stringify(data));
      // delete params.type
      if (this.type == "update") {//模板批量配费
        url = '/master/commissonTemplate/batchUpdateRate';
      }
      if (this.type == "init") {//产品费率比
        url = '/master/commissonTemplate/updateTemplateRate';
      }
      if (this.type == "mechan") {//团队批量配费
        url = '/master/commissonTemplate/batchUpdateSubCommissonsRate';
      }
      if (updateFee) {
        params.rate = (this.feeData.rate / 100).toFixed(4) * 1;
        params.rate2 = (this.feeData.rate2 / 100).toFixed(4) * 1;
        params.rate3 = (this.feeData.rate3 / 100).toFixed(4) * 1;
        params.rate4 = (this.feeData.rate4 / 100).toFixed(4) * 1;
        params.rate5 = (this.feeData.rate5 / 100).toFixed(4) * 1;
        params.scale = this.scale;
      }
      if (this.type == "add") {//新增模板
        this.$refs.modalLoading.open({
          title: "正在创建模板，请稍等...",
          content: "<div class='text1'><b>调整规则：</b>按照原费率在一级机构费率中的占比进行调整</div>"
            + "<div class='text2'>（如：一级为80%，下级为40%，即下级占一级费率的50%，当一级下调到30%时，系统将自动根据原服务费占比进行下调，即下级调整至15%）</div>"
        })
      } else if (this.type && this.type != "init") {//不是产品费率比
        this.$refs.modalLoading.open({
          title: "正在调整产品服务费，请稍等...",
          content: "<div class='text1'><b>调整规则：</b>按照原费率在一级机构费率中的占比进行调整</div>"
            + "<div class='text2'>（如：一级为80%，下级为40%，即下级占一级费率的50%，当一级下调到30%时，系统将自动根据原服务费占比进行下调，即下级调整至15%）</div>"
        })
      }
      return this.$http({
        url: url,
        type: 'POST',
        params: params,
      }).then(res => {
        this.$emit("save", this.type);
        this.visible = false;
        this.loading = false;
        if (!params.id || (this.type && this.type != "init")) {
          this.$refs.modalLoading.setText({
            title: "完成！",
            progress: 100
          })
        } else {
          this.$message.success("保存成功");
          return res;
        }
      }).catch(() => {
        this.loading = false;
        this.$refs.modalLoading.close();
      })

    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template /deep/ {
  .el-dialog__body {
    padding-top: 10px;
  }
  .text1 {
    font-size: 14px;
    margin-bottom: 18px;
    color: #888;
    span {
      color: $baseColor;
    }
  }
  .list-table {
    input {
      text-align: center;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: #fff;
  }
  .form-info-text {
    color: #888;
    font-size: 14px;
    line-height: 1.5;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .form-info-text2 {
    color: #666;
    line-height: 2;
    font-size: 14px;
    b {
      font-weight: bold;
      color: #333;
    }
  }
  .line {
    width: 820px;
    height: 1px;
    background-color: #ececec;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>